"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var matches_1 = require("./matches");
exports.filter = function (elements, selector) {
    return elements.filter(function (candidate) {
        return selector === undefined || matches_1.matches(candidate, selector);
    });
};
